import React, { useState, useEffect } from 'react'; // Added useEffect
import { Link } from 'react-router-dom';
import Popup from './Popup';
import Form from './Form';
import Logo from './images/Visa Consult Logo.jpg';

const NavBar = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  
  // NEW: State to track scroll position
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // If scroll is more than 50px, set isScrolled to true
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    /* NEW: Template literal to add 'scrolled' class conditionally */
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="primary-details">
        <p>Get in touch with a consultant +27 72 066 3578</p>
        <ul className="trading-hours">
          <li>Trading Hours:</li>
          <li>Mon - Fri: 08:00 - 17:00</li>
          <li>Closed during weekends</li>
        </ul>
        <span className="email">
          <strong>info@visionaryvisaconsultating.co.za</strong>
        </span>
        <button className="contact-btn" onClick={() => setIsPopupOpen(true)}>Book an appointment</button>
      </div>

      <div className="primary-nav">
        <Link to="/" className="logo-container" onClick={() => setIsNavOpen(false)}>
          <img src={Logo} alt="Visionary Visa Consultant Logo" className="logo-img" />
        </Link>

        <div className={`mobile-menu-toggle ${isNavOpen ? 'open' : ''}`} onClick={() => setIsNavOpen(!isNavOpen)}>
          <span className="menu-bar"></span>
          <span className="menu-bar"></span>
          <span className="menu-bar"></span>
        </div>

        <ul className={`nav-links ${isNavOpen ? 'open' : ''}`}>
          <li><Link to="/" onClick={() => setIsNavOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setIsNavOpen(false)}>About</Link></li>
          <li><Link to="/services" onClick={() => setIsNavOpen(false)}>Services</Link></li>
          <li><Link to="/contact" onClick={() => setIsNavOpen(false)}>Contact</Link></li>
        </ul>
      </div>

      <Popup trigger={isPopupOpen} setTrigger={setIsPopupOpen}>
        <Form />
      </Popup>
    </nav>
  );
};

export default NavBar;
